import styled from "styled-components";

import { colors } from "@/styles/Variants";

import { theme } from "../theme";

const { fontFamily } = theme;
const color = colors.bild;

export const PrimaryButton = styled.button<{ disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  height: 48px;
  width: 280px;
  text-decoration: none;
  cursor: pointer;
  font-family: ${fontFamily.gothamXNarrow};
  font-weight: 700;
  font-size: 17px;
  line-height: 1.2;
  text-transform: uppercase;
  padding: 18px 28px;
  border-radius: 8px;
  transition: all 250ms ease-in-out;
  background-color: ${color.red500};
  color: ${color.vader0};
  &:hover {
    background-color: ${color.red600};
  }
  &:disabled {
    background-color: ${color.vader25};
    color: ${color.vader200};
    cursor: not-allowed;
  }
`;

export const GhostButton = styled(PrimaryButton)`
  background-color: transparent;
  color: ${color.vader300};
  svg {
    path {
      fill: ${color.vader300};
      transition: all 250ms ease-in-out;
    }
  }
  &:hover {
    background-color: ${color.vader50};
    color: ${color.vader500};
  }
  &:disabled {
    background-color: transparent;
    color: ${color.vader200};
    cursor: not-allowed;
  }
`;

export const IconWrapper = styled.div<{ iconPosition?: "left" | "right" }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(props) => (props.iconPosition === "left" ? "8px" : "0")};
  margin-left: ${(props) => (props.iconPosition === "right" ? "8px" : "0")};
`;
